export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/clips-icon.svg?1f1e6d491e2a92306193b5208a73a8f5";